import React, { useState, useEffect } from 'react';

import MemeGenerator from './components/MemeGenerator';
import { CanvasProvider } from './hooks/useCanvas';

function App() {
  const [theme, setTheme] = useState('light');

  const loadTheme = () => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }

  const switchTheme = (theme) => {
    setTheme(theme);
    localStorage.setItem('theme', theme);
  }

  useEffect(() => {
    loadTheme();
  }, []);
  
  return (
    <CanvasProvider>
      <div className="text-center min-h-screen flex flex-col relative">
        <button 
          onClick={() => switchTheme(theme === 'light' ? 'dark' : 'light')} 
          className="absolute top-4 right-4 p-2 rounded-full bg-white border-2 border-[#f2a902] hover:border-[#f2a90250] hover:bg-gray-50 shadow-sm transition-colors flex items-center justify-center"
          aria-label={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
        >
          {theme === 'light' ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20">
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
            </svg>
          )}
        </button>
        <MemeGenerator theme={theme} />
        <img draggable={false} src="./yep.png" alt="yep" className="w-10 md:w-20 mr-4 absolute bottom-0 right-0" />
      </div>
    </CanvasProvider>
  );
}

export default App;
